import React from 'react';
import HelpApiLayout from '../../../components/layout/HelpApiLayout';
import ApiSidebar from '../../../components/layout/ApiSidebar';
import CodeExample from '../components/CodeExample';
import './ApiDocsPage.css';

/**
 * Authentication API Documentation Page
 */
const Authentication = () => {
  return (
    <HelpApiLayout type="api" sidebar={<ApiSidebar />}>
      <div className="api-docs-page">
        <div className="api-docs-page-container">
          <main className="api-docs-main">
            <header className="api-docs-page-header">
              <h1 className="lp-section-title">Authentication</h1>
              <p className="lp-section-subtitle">
                All API requests require authentication using API keys. Include your API key
                in the Authorization header of each request.
              </p>
            </header>

            <section className="api-docs-page-section">
              <h2>Getting Your API Key</h2>
              <p>
                Contact WeSplit to obtain an API key for your integration. API keys are provided to external partners for programmatic access.
              </p>
            </section>

            <section className="api-docs-page-section">
              <h2>Using Your API Key</h2>
              <p>Include your API key in the Authorization header:</p>
              <CodeExample
                code={`Authorization: Bearer YOUR_API_KEY`}
                language="http"
                title="Header"
              />
            </section>

            <section className="api-docs-page-section">
              <h2>Example Request</h2>
              <p>All external partner endpoints require API key authentication. Here's an example:</p>
              <CodeExample
                code={`curl -X POST "https://us-central1-wesplit-35186.cloudfunctions.net/createSplitFromPayment" \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "email": "user@example.com",
    "invoiceId": "invoice_123",
    "amount": 100.0,
    "currency": "USD",
    "source": "your_company_name"
  }'`}
                language="bash"
                title="cURL Example"
              />
            </section>

            <section className="api-docs-page-section">
              <h2>Security Best Practices</h2>
              <ul>
                <li>Never commit API keys to version control</li>
                <li>Store API keys securely in environment variables</li>
                <li>Rotate API keys regularly</li>
                <li>Use different API keys for development and production</li>
                <li>If an API key is compromised, contact WeSplit immediately to revoke it</li>
              </ul>
            </section>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Authentication;
